import { Utils } from "@/lib/utility/utils";
import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivDocumentRequestResponseControllerGetParamsGen,
  MrfiktivDocumentRequestResponseControllerRespondParamsGen,
  MrfiktivDocumentRequestResponseDtoGen
} from "../v1/data-contracts";
import { DocumentRequestResponse } from "../v1/DocumentRequestResponse";
import { HttpClient } from "../v1/http-client";

class DocumentRequestResponseService {
  client: HttpClient;
  mrfiktivProxy: DocumentRequestResponse;

  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.client = mrfiktivHttpClientProvider.client();
    this.mrfiktivProxy = new DocumentRequestResponse(this.client);
  }

  async getDocumentBySharedAccessToken(data: MrfiktivDocumentRequestResponseControllerGetParamsGen) {
    return (await this.mrfiktivProxy.documentRequestResponseControllerGet(data)).data;
  }

  async respond(
    query: MrfiktivDocumentRequestResponseControllerRespondParamsGen,
    data: MrfiktivDocumentRequestResponseDtoGen & { files?: File[] }
  ) {
    const form = new FormData();
    Utils.buildFormData(form, data);

    // Does not work.. The Files are not processed well in the form data builder of the generated client
    // return (await this.mrfiktivProxy.documentRequestResponseControllerRespond(query, data as any)).data;

    return (
      await this.client.instance.patch(
        `/partner/${query.partnerId}/document-request-response/${query.documentRequestId}`,
        form,
        { params: { sct: query.sct } }
      )
    ).data;
  }
}

export default new DocumentRequestResponseService(new MrfiktivHttpClientProvider());
